import {
  ContactHistory,
  DataFile,
  JobAttachmentHistory,
  StudentDetail,
  StudentImportDiff,
  StudentImportErrorDeleteRequest,
  StudentImportErrorDetail,
  StudentImportFile,
  StudentImportQueue,
  StudentList,
  StudentNote,
  StudentReimportRequest,
  StudentSuggestResponse,
  StudentUpdateRequest,
} from '@agent-ds/shared/interfaces';
import { SituationMemo } from '@agent-ds/shared/interfaces/memo';
import { ApiService } from '@agent-ds/shared/models/api-service';
import { CACHE } from '@agent-ds/shared/util/cache';
import { downloadResponse } from '@agent-ds/shared/util/util';
import { StudentSearchRequest } from '@agent-ds/student/dto/studentSearchRequest';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { merge, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { REPORT_SUCCESS_HEADER } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerApiService extends ApiService {
  constructor(private http: HttpClient) {
    super();
  }

  getList(search: StudentSearchRequest): Observable<StudentList> {
    return this.http.get<StudentList>('/api/customer/search', { params: search as any });
  }

  getDetail(id: number): Observable<StudentDetail> {
    return this.http.get<StudentDetail>('/api/customers/' + id).pipe(
      tap((student) => {
        student.userId = student.studentUsers && student.studentUsers.length ? student.studentUsers[0].userId : null;
        // 副担当者のIDを抽出
        if (student.studentSubUsers && student.studentSubUsers.length) {
          student.subUserIds = student.studentSubUsers.map((studentSubUser) => {
            return studentSubUser.userId;
          });
        } else {
          // do nothing
        }
        return student;
      }),
    );
  }

  /*
  後々拡張の可能性あり
  updateMemo(id: number, memo: SituationMemo): Observable<any> {
    return this.http.put(`/api/customers/${id}/memos/${memo.id}`, memo);
  }

  updateNote(studentId: number, note: StudentNote): Observable<any> {
    return this.http.put(`/api/customers/${studentId}/note/${note.id}`, note);
  }
  */

  updateExpectedCompanyFlag(studentId: number, currentProgressId: number, updateProgressId: number): Observable<any> {
    return this.http.put(`/api/customer/expected/${studentId}/${currentProgressId}/${updateProgressId}`, {});
  }
}
